import React from 'react';
import classNames from 'classnames';

import { CartIcon } from './CartIcon';
import propTypes from 'prop-types';

export default class CartTrigger extends React.Component {
  static propTypes = {
    totalItems: propTypes.number,
    headerOverlayClassName: propTypes.string,
  };

  static defaultProps = {
    headerOverlayClassName: 'header__overlay',
  };

  handleTriggerClick = () => {
    this.props.toggleCartVisibility();
  };

  // react does not own the overlay dom element so
  // we have to use a method like this to work-around that
  componentDidMount = () => {
    this.closeTargetEl = document.getElementsByClassName(
      this.props.headerOverlayClassName
    )[0];
    this.closeTargetEl.addEventListener('click', this.onHeaderClick);
  };

  componentWillUmount = () => {
    this.closeTargetEl.removeEventListener('click', this.onHeaderClick);
    this.closeTargetEl = null;
  };

  onHeaderClick = () => {
    if (this.props.isOpen) {
      this.handleTriggerClick();
    }
  };

  render() {
    const { totalItems, isOpen } = this.props;

    const rootClassNames = classNames('CartTrigger', {
      'CartTrigger--open': isOpen,
      'CartTrigger--closed': !isOpen,
    });

    return (
      <div className={rootClassNames} onClick={this.handleTriggerClick}>
        <CartIcon totalItems={totalItems} />
      </div>
    );
  }
}
